import { render, staticRenderFns } from "./PlayerSummary.vue?vue&type=template&id=0cb32b5e&"
import script from "./PlayerSummary.vue?vue&type=script&lang=js&"
export * from "./PlayerSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports